import React from 'react';
import { Box, Stack, Typography, useTheme } from '@mui/material';

import { PurchaseOrderRecommendation } from '@domain/purchasing';
import { getISOWeek, getISOWeekYear } from 'date-fns';

interface ForecastWaterfallChartProps {
  recommendation: PurchaseOrderRecommendation;
  processedDate: Date;
}


const ForecastWaterfallChart: React.FC<ForecastWaterfallChartProps> = ({ recommendation, processedDate }) => {
  const theme = useTheme();

  const forecast = recommendation.inventoryForecast ?? [];
  const maxForecastQuantity = Math.max(
    recommendation.recommendedQuantity,
    forecast.reduce((max, week) => Math.max(max, week.endInventory), 0),
  );


  const getBarChartData = () => {
    let purchasedAmount = recommendation.recommendedQuantity;

    const barChartData = forecast.map((week) => {
      let purchasingWeek = false;
      let quantity = week.endInventory;

      if (processedDate && week.year > getISOWeekYear(processedDate) || (week?.week >= getISOWeek(processedDate) && week.year === getISOWeekYear(processedDate))) {
        quantity = week.endInventory + purchasedAmount;
        purchasedAmount -= week.outbounds.reduce((acc, curr) => acc + curr.quantity, 0);

        if (week?.week === getISOWeek(processedDate) && week.year === getISOWeekYear(processedDate)) {
          purchasingWeek = true;
        }
      }



      return {
        week: week.week,
        quantity: quantity,
        color: purchasingWeek ? theme.palette.primary.main : theme.palette.secondary.main
      }
    })

    return barChartData;
  }

  return (
    <Stack
      direction="row"
      alignItems="flex-end"
      justifyContent="space-between"

    >
      {getBarChartData()?.map((week, index) => {
        const quantity = week.quantity
        const height = quantity / maxForecastQuantity * 100

        return (
          <Box
            flex={1}
            position="relative"
          >
            <Box
              className='graph-view-bar-container'
              key={`${recommendation.item.product.id}-week-${week.week}-${index}`}

              sx={{
                gap: 0.5,
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'flex-end',
                alignItems: 'center',
              }}
            >

              <Box
                sx={{
                  position: 'relative',
                  height: 50,
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'flex-end',
                  alignItems: 'center',
                  gap: 0.5,
                  borderRadius: '4px',
                }}
              >

                <Box
                  className="graph-view-bar"
                  sx={{
                    width: '6px',
                    height: `${height}%`,
                    backgroundColor: week.color,
                    borderRadius: '4px',
                    transition: 'height 0.1s ease-in-out',
                    transitionDelay: `${index * 0.01}s`,
                    '--bar-height': `${height}%`
                  }} />
              </Box>

              <Typography
                variant="caption"
                textAlign="center"
                fontSize={12}
                color="text.secondary"
                noWrap >
                {week.week}
              </Typography>
            </Box>
          </Box>
        )
      })}
    </Stack>

  );
};



export default ForecastWaterfallChart;
